module.exports = __webpack_public_path__ + "img/web_02.2c0d3783.png";